import Vue from 'vue';
import Router from 'vue-router';
// import GoodsDetail from './pages/goods/detail/index.vue';
import NotFoundComponent from '@/pages/notfound/index.vue';
// import { judgeLoginV2 } from './utils/user';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '*', component: NotFoundComponent },
    {
      path: '/goods/detail',
      name: 'goods_detail',
      // route level code-splitting
      // this generates a separate chunk (goods_detail.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "goods_detail" */ './pages/goods/detail/index.vue'),
    },
    {
      path: '/goods/comments',
      name: 'goods_comments',
      component: () => import(/* webpackChunkName: "goods_comments" */ './pages/goods/comments/index.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "cart" */ './pages/home/index.vue'),
      meta: {
        keepAlive: true, // 需要被缓存
      },
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ './pages/cart/index.vue'),
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import(/* webpackChunkName: "pay" */ './pages/pay/index/index.vue'),
    },
    {
      path: '/address/edit',
      name: 'address_edit',
      component: () => import(/* webpackChunkName: "address_edit" */ './pages/address/edit/index.vue'),
    },
    {
      path: '/address/manage',
      name: 'address_manage',
      component: () => import(/* webpackChunkName: "address_manage" */ './pages/address/manage/index.vue'),
    },
    {
      path: '/pay/success',
      name: 'pay_success',
      component: () => import(/* webpackChunkName: "pay_success" */ './pages/pay/success/index.vue'),
    },
    {
      path: '/order/all',
      name: 'order_all',
      component: () => import(/* webpackChunkName: "order_all" */ './pages/order/all/index.vue'),
    },
    {
      path: '/express',
      name: 'express',
      component: () => import(/* webpackChunkName: "express" */ './pages/express/index.vue'),
    },
    {
      path: '/help',
      name: 'help',
      component: () => import(/* webpackChunkName: "help" */ './pages/help/index.vue'),
    },
    {
      path: '/my',
      name: 'my',
      component: () => import(/* webpackChunkName: "my" */ './pages/my/index.vue'),
    },
    {
      path: '/order/detail',
      name: 'order_detail',
      component: () => import(/* webpackChunkName: "order_detail" */ './pages/order/detail/index.vue'),
    },
    {
      path: '/comment',
      name: 'comment',
      component: () => import(/* webpackChunkName: "comment" */ './pages/comment/index.vue'),
    },
    {
      path: '/refund/apply',
      name: 'refund_apply',
      component: () => import(/* webpackChunkName: "refund_apply" */ './pages/refund/apply/index.vue'),
    },
    {
      path: '/refund/list',
      name: 'refund_list',
      component: () => import(/* webpackChunkName: "refund_list" */ './pages/refund/list/index.vue'),
    },
    {
      path: '/refund/detail',
      name: 'refund_detail',
      component: () => import(/* webpackChunkName: "refund_detail" */ './pages/refund/detail/index.vue'),
    },
    {
      path: '/browse_history',
      name: 'browse_history',
      component: () => import(/* webpackChunkName: "browse_history" */ './pages/browseHistory/index.vue'),
    },
    {
      path: '/soldout',
      name: 'soldout',
      component: () => import(/* webpackChunkName: "soldout" */ './pages/goods/soldout/index.vue'),
    },
    {
      path: '/iframe',
      name: 'iframe',
      component: () => import(/* webpackChunkName: "iframe" */ './pages/iframe/index.vue'),
    },
    {
      path: '/refund/express',
      name: 'refund_express',
      component: () => import(/* webpackChunkName: "refund_express" */ './pages/refund/express/index.vue'),
    },
    {
      path: '/topic',
      name: 'topic',
      component: () => import(/* webpackChunkName: "topic" */ './pages/topic/index.vue'),
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import(/* webpackChunkName: "coupon" */ './pages/coupon/index.vue'),
    },
    {
      path: '/coupon/goods',
      name: 'coupon_goods',
      component: () => import(/* webpackChunkName: "coupon" */ './pages/coupon/goods/index.vue'),
    },
    {
      path: '/share/coupon',
      name: 'share_coupon',
      component: () => import(/* webpackChunkName: "share_coupon" */ './pages/shareCoupon/index.vue'),
    },
    {
      path: '/freeCoupon',
      name: 'freeCoupon',
      component: () => import(/* webpackChunkName: "share_coupon" */ './pages/coupon/freePickUp.vue'),
    },
    {
      path: '/homeTest',
      name: 'homeTest',
      component: () => import(/* webpackChunkName: "homeTest" */ './pages/homeTest/index.vue'),
      meta: {
        keepAlive: true, // 需要被缓存
      },
    },
    {
      path: '/class',
      name: 'class',
      component: () => import(/* webpackChunkName: "homeTest" */ './pages/class/index.vue'),
      meta: {
        keepAlive: true, // 需要被缓存
      },
    },
    {
      path: '/mineCf', // 我的众筹
      name: 'mineCf',
      component: () => import(/* webpackChunkName: "mineCf" */ './pages/crowdfunding/mine/index.vue'),
    },
    {
      path: '/cfDet', // 众筹商品详情
      name: 'cfDet',
      component: () => import(/* webpackChunkName: "cfDet" */ './pages/crowdfunding/detail/index.vue'),
    },
    {
      path: '/cfPay', // 付款页面，确认订单
      name: 'cfPay',
      component: () => import(/* webpackChunkName: "cfPay" */ './pages/crowdfunding/pay/index.vue'),
    },
    {
      path: '/cfOrderInfo', // 订单详情
      name: 'cfOrderInfo',
      component: () => import(/* webpackChunkName: "cfOrderInfo" */ './pages/crowdfunding/orderinfo/index.vue'),
    },
    {
      path: '/linkCoupon', // 订单详情
      name: 'linkCoupon',
      component: () => import(/* webpackChunkName: "cfOrderInfo" */ './pages/coupon/linkCoupon/index.vue'),
    },
    {
      path: '/member', // 会员权益
      name: 'member',
      component: () => import('./pages/member/index.vue'),
    },
    {
      path: '/member/pay', // 会员购买
      name: 'memberPay',
      component: () => import('./pages/member/pay/index.vue'),
    },
    {
      path: '/member/success', // 会员购买成功
      name: 'memberSuccess',
      component: () => import('./pages/member/success/index.vue'),
    },
    {
      path: '/invoice', // 开具发票
      name: 'invoice',
      component: () => import('./pages/invoice/entrance/index.vue'),
    },
    {
      path: '/invoice/title', // 发票抬头
      name: 'invoiceTitle',
      component: () => import('./pages/invoice/title/index.vue'),
    },
    {
      path: '/invoice/title/edit', // 发票编辑
      name: 'invoiceTitleEdit',
      component: () => import('./components/invoice/title/edit/index.vue'),
    },
    {
      path: '/invoice/history', // 开票历史
      name: 'invoiceHistory',
      component: () => import('./pages/invoice/history/index.vue'),
    },
    {
      path: '/invoice/history/detail', // 开票历史-发票详情
      name: 'invoiceHistoryDetail',
      component: () => import('./components/invoice/history/detail/index.vue'),
    },
    {
      path: '/invoice/history/order', // 开票历史-查看订单
      name: 'invoiceHistoryOrder',
      component: () => import('./components/invoice/history/order/index.vue'),
    },
    {
      path: '/invoice/history/again', // 开票历史-重发发票
      name: 'invoiceHistoryAgain',
      component: () => import('./components/invoice/history/again/index.vue'),
    },
    {
      path: '/invoice/order', // 商城消费开票-订单选择
      name: 'invoiceOrder',
      component: () => import('./pages/invoice/order/index.vue'),
    },
    {
      path: '/invoice/issue', // 开具发票
      name: 'invoiceIssue',
      component: () => import('./components/invoice/issue/index.vue'),
    },
    {
      path: '/invoice/info', // 开具发票-发票详情
      name: 'invoiceInfo',
      component: () => import('./components/invoice/info/index.vue'),
    },
    {
      path: '/invoice/result', // 开具发票-发票结果
      name: 'invoiceResult',
      component: () => import('./components/invoice/result/index.vue'),
    },
    // ,
    // {
    //     path: '/activity/manghe',
    //     name: 'manghe',
    //     component: () => import(/* webpackChunkName: "share_coupon" */ './pages/activity/manghe/index.vue'),
    // },
    // {
    //     path: '/activity/manghe/buy',
    //     name: 'manghe_entry',
    //     component: () => import(/* webpackChunkName: "share_coupon" */ './pages/activity/manghe/buy/index.vue'),
    //     beforeEnter: (to, from, next) => {
    //         judgeLoginV2(function () {
    //             next();
    //         });
    //     }
    // }
  ],
});
